import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {ifDefined} from 'lit/directives/if-defined.js';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from "@webs/components-library/theming";

@customElement('webs-content-text-specs-list')
export class ContentTextSpecsList extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`
    .m-content-text-specs-list__title {
    }
    `]
  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property()
  id: string;

  @property()
  title: string;

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}"
           class="m-content-text-specs-list ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div  class="container ">
          <slot name="title"></slot>
          <slot name="content"></slot>
        </div>


      </section>

    `
  }
}
